import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DirectAccessGuard, SearchParamManagerService } from '@app/core';
import { CONTENT_ROUTES } from '@app/shared';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivateChild: [DirectAccessGuard],
    children: CONTENT_ROUTES
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  private currentRoot: string;

  constructor(
    router: Router,
    private searchParamManagerService: SearchParamManagerService,
    private modal: BsModalService,
  ) {
    router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe(this.onNavigationStart.bind(this));
  }

  private onNavigationStart(event: NavigationStart) {
    // Modalをすべて閉じる
    if (this.modal.getModalsCount() > 0) {
      this.modal.hide();
    }
    // 保存している検索条件をクリアする
    const nextRoot = event.url.split('/')[1];
    if (!this.currentRoot || nextRoot !== this.currentRoot) {
      this.searchParamManagerService.notifyAllClear();
    }
    this.currentRoot = event.url.split('/')[1];
  }
}
